export default __webpack_public_path__ + "static/Plots0078-43725d27421825c2d7219e89f389a236.jpg";